import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showErrorMsg, showInfoMsg, showSuccessMsg } from './ValidationHelper';
import rootAction from '../stateManagment/actions/rootAction';


export const AddProductToCart = (ProductId, 
    Quantity, productSelectedAttributes, DefaultImage, selectedVariation = null) => {
    let cartItems = [];
    try {
      
       
        cartItems = JSON.parse(localStorage.getItem("cartItems"))
        cartItems = cartItems ?? [];

        Quantity = Number(Quantity);
        if (!Number.isInteger(Quantity) || Quantity < 1) {
            showErrorMsg('Select a valid quantity.');
            return JSON.stringify(cartItems);
        }
        if (selectedVariation && (!selectedVariation.id || selectedVariation.price == null ||
            !Number.isFinite(Number(selectedVariation.price)) || Number(selectedVariation.price) <= 0 ||
            !Number.isInteger(selectedVariation.stock) || selectedVariation.stock < Quantity)) {
            showErrorMsg('The selected variant is unavailable or has insufficient stock.');
            return JSON.stringify(cartItems);
        }
        const existingIndex = cartItems.findIndex(obj => obj.ProductId == ProductId);
        const selection = {
            SelectedVariantId: selectedVariation?.id || null,
            SelectedVariantName: selectedVariation?.name || null
        };
        // The cart stores one configuration per product. Switching a variant replaces it.
        if (existingIndex >= 0 && (cartItems[existingIndex].SelectedVariantId || null) !== selection.SelectedVariantId) {
            cartItems[existingIndex] = { ...cartItems[existingIndex], ...selection, productSelectedAttributes, Quantity, DefaultImage };
            localStorage.setItem('cartItems', JSON.stringify(cartItems));
            showSuccessMsg('Variant updated in your cart!');
            return JSON.stringify(cartItems);
        }
        if (existingIndex >= 0) {
            showInfoMsg("Product already exists in your cart!");
            return JSON.stringify(cartItems);
        } else {
            cartItems.push({
                ProductId: ProductId,
                ...selection,
                productSelectedAttributes : productSelectedAttributes,
                Quantity: Quantity,
                ShippingCharges : 0,
                DefaultImage: DefaultImage
            });

            console.log(cartItems);

            

            //--store in storage
            localStorage.setItem("cartItems", JSON.stringify(cartItems));

            showSuccessMsg("Added to the cart!");
              return JSON.stringify(cartItems);;
        }
    }
    catch (err) {
        console.log(err);
        showErrorMsg("An error occured. Please try again!");
          return JSON.stringify(cartItems);;
    }



};

export const AddCustomerWishList = (ProductId, ProductName  , Price,  DiscountedPrice  , DiscountId    ,
     IsDiscountCalculated, CouponCode   ,
     SizeId,  SizeShortName  , ColorId,  ColorName , Quantity, DefaultImage) => {
    let customerWishList = [];
    try {
        
       
        customerWishList = JSON.parse(localStorage.getItem("customerWishList"))
        customerWishList = customerWishList ?? [];

        //--check if product already exists
        if (customerWishList?.filter(obj => obj.ProductId == ProductId).length > 0) {
            showInfoMsg("Product already exists in your wish list!");
            return JSON.stringify(customerWishList);
        } else {
            customerWishList.push({
                ProductId: ProductId,
                ProductName : ProductName,
                Price: Price,
                DiscountedPrice : DiscountedPrice, 
                DiscountId :DiscountId   ,
                IsDiscountCalculated :IsDiscountCalculated, 
                CouponCode :CouponCode ,
                SizeId: SizeId,
                SizeShortName : SizeShortName,
                ColorId: ColorId,
                ColorName: ColorName,
                Quantity: Quantity,
                ShippingCharges: 0 ,
                DefaultImage: DefaultImage
            });

            console.log(customerWishList);

            showSuccessMsg("Added to your wish list!");
              return JSON.stringify(customerWishList);;
        }
    }
    catch (err) {
        console.log(err);
        showErrorMsg("An error occured. Please try again!");
          return JSON.stringify(customerWishList);;
    }



};
